(function () {
  let swiperPopularProducts;

  /* ============================================================
     SWIPER / SLIDER LOGIC
     ============================================================ */

  const updateNavPosition = (section) => {
    const nav = section.querySelector(".pp2-nav");
    if (!nav) return;
    const firstSlide = section.querySelector(".pp2-item");
    if (!firstSlide) return;
    const imgWrapper = firstSlide.querySelector(".pp2-card");
    if (!imgWrapper) return;
    const swiperEl = section.querySelector(".pp2-layout");
    if (!swiperEl) return;
    const swiperRect = swiperEl.getBoundingClientRect();
    const imgRect = imgWrapper.getBoundingClientRect();
    const offsetTop = imgRect.top - swiperRect.top;
    const centerY = offsetTop + imgRect.height / 2;
    nav.style.top = `${centerY}px`;
  };

  const initSlider = (section) => {
    if (!section || !section?.classList.contains("pp2-section")) return;
    const swiperEl = section.querySelector(".pp2-layout");
    const swiperWrapper = section.querySelector(".pp2-list");
    const slides = section.querySelectorAll(".pp2-item");
    if (!swiperEl || !swiperWrapper || !slides || !slides.length) return;

    swiperEl.classList.add("swiper");
    swiperWrapper.classList.add("swiper-wrapper");
    slides.forEach((slide) => slide.classList.add("swiper-slide"));

    const prevBtn = section.querySelector(".pp2-nav-button--prev");
    const nextBtn = section.querySelector(".pp2-nav-button--next");
    const columns = Number(swiperEl.dataset.columns) || 3;
    const isCenteredSlides = Boolean(swiperEl.dataset.centeredSlides);
    const isLoop = Boolean(swiperEl.dataset.loop);

    const breakpointsConfig = {
      2: {
        576: { slidesPerView: 2.1, spaceBetween: 20 },
        990: { slidesPerView: 2.1, spaceBetween: 24 },
      },
      3: {
        576: { slidesPerView: 2.1, spaceBetween: 20 },
        990: { slidesPerView: 3.15, spaceBetween: 24 },
      },
      4: {
        576: { slidesPerView: 2.1, spaceBetween: 20 },
        990: { slidesPerView: 3.15, spaceBetween: 24 },
        1360: { slidesPerView: 4.15, spaceBetween: 24 },
      },
      5: {
        576: { slidesPerView: 2.1, spaceBetween: 20 },
        990: { slidesPerView: 3.15, spaceBetween: 24 },
        1360: { slidesPerView: 5.15, spaceBetween: 24 },
      },
    };

    const centeredSlidesBreakpointsConfig = {
      576: { slidesPerView: 1.5, spaceBetween: 20 },
      990: { slidesPerView: 3.15, spaceBetween: 24 },
    };

    const sliderOptions = {
      slidesPerView: 1.15,
      spaceBetween: 16,
      speed: 800,
      allowTouchMove: true,
      loop: isLoop,
      centeredSlides: isCenteredSlides,
      centeredSlidesBounds: isCenteredSlides,
      breakpoints: isCenteredSlides
        ? centeredSlidesBreakpointsConfig
        : breakpointsConfig[columns],
      mousewheel: { forceToAxis: true },
      a11y: { scrollOnFocus: false },
      preventClicks: true,
      navigation:
        nextBtn && prevBtn
          ? {
              nextEl: nextBtn,
              prevEl: prevBtn,
              disabledClass: "swiper-button-disabled",
            }
          : false,
    };

    swiperPopularProducts = new Swiper(swiperEl, sliderOptions);
    updateNavPosition(section);
    const nav = section.querySelector(".pp2-nav");
    if (nav) nav.classList.add("pp2-nav--visible");
  };

  const destroySlider = (section) => {
    if (!swiperPopularProducts || !section) return;
    const swiperEl = section.querySelector(".pp2-layout");
    const swiperWrapper = section.querySelector(".pp2-list");
    const slides = section.querySelectorAll(".pp2-item");
    if (!swiperEl || !swiperWrapper || !slides || !slides.length) return;
    swiperPopularProducts.destroy(true, true);
    swiperPopularProducts = null;
    swiperEl.classList.remove("swiper");
    swiperWrapper.classList.remove("swiper-wrapper");
    slides.forEach((slide) => slide.classList.remove("swiper-slide"));
  };

  const initPopularProducts = (section) => {
    if (!section || !section?.classList.contains("pp2-section")) return;
    const mainContainer = section.querySelector(".pp2");
    if (!mainContainer) return;
    const desktopLayout = mainContainer.dataset.layout;
    const mobileLayout = mainContainer.dataset.layoutMobile;
    let currentLayout = null;

    const sectionResizeObserver = new ResizeObserver((entries) => {
      const [entry] = entries;
      let newLayout;
      if (entry.contentRect.width < 576) {
        newLayout = mobileLayout;
      } else {
        newLayout = desktopLayout;
      }
      if (newLayout !== currentLayout) {
        if (swiperPopularProducts) destroySlider(section);
        if (newLayout === "slider") initSlider(section);
        currentLayout = newLayout;
      }
      if (currentLayout === "slider") updateNavPosition(section);
    });
    sectionResizeObserver.observe(section);
  };

  const initHeadingAnimation = (section) => {
    if (!section || !section?.classList.contains("pp2-section")) return;
    const enableAnimation = section.querySelector("[data-enable-header-animation]");
    if (!enableAnimation) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const target = entry.target;
            target.classList.add("anim-active");
            observer.unobserve(target);
          }
        });
      },
      { threshold: 0, rootMargin: "0px 0px -25% 0px" }
    );
    observer.observe(section);
  };

  /* ============================================================
     INIT
     ============================================================
     Add to Cart NO se maneja aquí. Cada card usa <product-form>
     del tema, que ya está cargado globalmente y conecta con el
     cart-drawer custom element automáticamente.
     ============================================================ */

  if (document.currentScript && document.currentScript.parentElement) {
    initPopularProducts(document.currentScript.parentElement);
    initHeadingAnimation(document.currentScript.parentElement);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initPopularProducts(event.target);
    initHeadingAnimation(event.target);
  });
})();